module.exports = __webpack_public_path__ + "static/media/photo-1.8dab4621.jpg";